import { Content, Page } from '@backstage/core-components';
import { Grid, makeStyles } from '@material-ui/core';
import {
  QuickActionsCard,
  SlalomHeader,
  StarredTemplatesCard,
  RecentTemplateChanges,
} from '../../cards';
import { AnnouncementsCard } from '@backstage-community/plugin-announcements';
import {
  HomePageRecentlyVisited,
  HomePageTopVisited,
} from '@backstage/plugin-home';
import { QuickLinksDisplay } from '../../home/quick-links/QuickLinksDisplay';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(4),
  },
}));

export const HomePage = () => {
  const classes = useStyles();

  return (
    <Page themeId="slalomLightTheme">
      <Content className={classes.container}>
        <SlalomHeader />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <StarredTemplatesCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <QuickLinksDisplay />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageRecentlyVisited />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageTopVisited />
          </Grid>
          <Grid item xs={12} md={6}>
            <AnnouncementsCard current active />
          </Grid>
          <Grid item xs={12} md={6}>
            <RecentTemplateChanges />
          </Grid>
          <Grid item xs={12} md={6}>
            <QuickActionsCard />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
